import { render } from "./BaseLabel.vue?vue&type=template&id=63ace06e&ts=true"
import script from "./BaseLabel.vue?vue&type=script&lang=ts"
export * from "./BaseLabel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__